import dropRight from "./dropRight.js";
export default function dropLast(iter) {
  return dropRight(1, iter);
}
